import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ToastService } from '../../services/toast.service';
import { SuperAdminService } from '@core/services/super-admin.service';
import { Router } from '@angular/router';
import { DriverService } from '../driver/services/driver.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrls: ['./delete-confirmation-modal.component.scss'],
})
export class DeleteConfirmationModalComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  bodyText = '';
  headerText = '';
  id = '';
  fullUrl: string;
  isGroupUser: boolean = false;
  isForceFully: boolean = false;
  constructor(
    private readonly router: Router,
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly toastService: ToastService,
    private readonly driverService: DriverService,
    private readonly superAdminService: SuperAdminService) { }


  ngOnInit(): void {
    this.getCurrentUrl();
    this.bodyText = this.config?.data?.bodyText;
    this.headerText = this.config?.data?.headerText;
    this.id = this.config?.data?.id;
    this.isGroupUser = this.config?.data?.isGroupUser;
    this.isForceFully = this.config?.data?.isForceFully ?? false;
  }

  getCurrentUrl(): void {
    this.fullUrl = this.router.url;
  }
  deleteDriverAccountBySuperAdmin(driverId: string) {

    const payload = {
      id: driverId
    };
    this.superAdminService.deleteDriverAccountBySuperAdmin(payload)
    .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
      next: (res: any) => {
        this.ref.close();

          this.toastService.showToastMessage('success', 'Success', res.message);
          if (this.fullUrl.includes("/super-admin/driver-info") || ("/super-admin/group-operator-info") ) {
            const currentUrl = this.router.url;
            this.driverService.setPreviousUrl(currentUrl);
            this.router.navigate(['/super-admin/user-database-list']);
          }
        }, error: (error) => {
          this.ref.close();
          this.toastService.showToastMessage('error', 'Error', error.error.message);
        }
      })
  }

  cancel(): void {
    this.ref.close();

  }

}
